(function () {
  const initAsideMenu = () => {
    const header = document.querySelector(".header-wrapper");
    const asideMenu = document.querySelector(".aside-menu");
    const openAsideMenuBtn = document.querySelector(".aside-menu__toggle--open-btn");
    const closeMenuBtn = document.querySelector(".aside-menu__toggle--full-close-btn");
    const asideMenuOverlay = document.querySelector(".aside-menu__overlay");

    if (!asideMenu || !openAsideMenuBtn) return;

    let globalLeaveTimeout;
    let isTransitioning = false;

    const closeAllLevels = () => {
      const activeItems = asideMenu.querySelectorAll(".first_level_details.active, .second_level_details.active");
      activeItems.forEach((item) => {
        item.classList.remove("active");
        item.classList.add("hiding");
        setTimeout(() => item.classList.remove("hiding"), 800);
      });
    };

    const openAsideMenu = (e) => {
      if (e && e.preventDefault) e.preventDefault();
      if (asideMenu.classList.contains("aside-menu--open")) return;
      clearTimeout(globalLeaveTimeout);
      isTransitioning = true;
      if (header) header.preventHide = true;
      asideMenu.classList.add("aside-menu--open");
      asideMenuOverlay.classList.add("aside-menu__overlay--active");
      document.body.classList.add("overflow-hidden-aside");
      setTimeout(() => { isTransitioning = false; }, 400);
    };

    const closeAsideMenu = (e) => {
      if (isTransitioning) return;
      if (e && e.preventDefault) e.preventDefault();
      asideMenu.classList.remove("aside-menu--open");
      asideMenuOverlay.classList.remove("aside-menu__overlay--active");
      document.body.classList.remove("overflow-hidden-aside");
      closeAllLevels();
      if (header) header.preventHide = false;
    };

    const menuTriggerSetting = asideMenu.dataset.menuTrigger || "click";
    const useHover = menuTriggerSetting === "hover";

    if (useHover) {
      openAsideMenuBtn.addEventListener("mouseenter", openAsideMenu);
      openAsideMenuBtn.addEventListener("mouseleave", () => {
        globalLeaveTimeout = setTimeout(closeAsideMenu, 300);
      });
    } else {
      openAsideMenuBtn.addEventListener("click", openAsideMenu);
    }

    asideMenu.addEventListener("click", (e) => {
      const target = e.target;

      if (target.closest(".aside-menu__toggle--close-btn") || target.closest(".aside-menu__toggle--full-close-btn") || target === asideMenuOverlay) {
        if (target === asideMenuOverlay && isTransitioning) return;
        
        const parentActive = target.closest(".active");
        if (parentActive && !target.closest(".aside-menu__top_main")) {
          e.stopPropagation();
          parentActive.classList.remove("active");
          parentActive.classList.add("hiding");
          parentActive.querySelectorAll(".active").forEach(child => {
             child.classList.remove("active");
             child.classList.add("hiding");
          });
          setTimeout(() => parentActive.classList.remove("hiding"), 800);
        } else {
          closeAsideMenu(e);
        }
        return;
      }

      const trigger = target.closest(".menu-trigger");
      if (trigger && !useHover) {
        e.preventDefault();
        e.stopPropagation();

        const currentItem = trigger.closest(".first_level_details, .second_level_details");
        if (!currentItem) return;

        const isActive = currentItem.classList.contains("active");
        const isFirstLevel = currentItem.classList.contains("first_level_details");

        if (isFirstLevel) {
          document.querySelectorAll(".first_level_details.active").forEach((other) => {
            if (other !== currentItem) {
              other.classList.remove("active");
              other.classList.add("hiding");
              other.querySelectorAll(".active").forEach(sub => sub.classList.remove("active"));
              setTimeout(() => other.classList.remove("hiding"), 800);
            }
          });
        } else {
          const parentSubmenu = currentItem.closest(".aside-menu__inner-submenu");
          if (parentSubmenu) {
             parentSubmenu.querySelectorAll(".second_level_details.active").forEach((other) => {
                if (other !== currentItem) {
                  other.classList.remove("active");
                  other.classList.add("hiding");
                  setTimeout(() => other.classList.remove("hiding"), 800);
                }
             });
          }
        }

        if (!isActive) {
          currentItem.classList.add("active");
        } else {
          currentItem.classList.remove("active");
          currentItem.classList.add("hiding");
          setTimeout(() => currentItem.classList.remove("hiding"), 800);
        }
      }
    });

    if (useHover) {
      asideMenu.addEventListener("mouseenter", (e) => {
        const item = e.target.closest(".first_level_details, .second_level_details");
        if (item) {
          clearTimeout(globalLeaveTimeout);
          item.classList.add("active");
        }
        if (e.target === asideMenu) clearTimeout(globalLeaveTimeout);
      }, true);

      asideMenu.addEventListener("mouseleave", (e) => {
        const item = e.target.closest(".first_level_details, .second_level_details");
        if (item) {
          setTimeout(() => {
            if (!item.matches(':hover')) {
              item.classList.remove("active");
              item.classList.add("hiding");
              setTimeout(() => item.classList.remove("hiding"), 800);
            }
          }, 150);
        }
        if (e.target === asideMenu) {
          globalLeaveTimeout = setTimeout(closeAsideMenu, 300);
        }
      }, true);

      if (asideMenuOverlay) {
        asideMenuOverlay.addEventListener("mouseenter", () => {
          if (!isTransitioning) closeAsideMenu();
        });
      }
    }

    asideMenuOverlay.addEventListener("click", closeAsideMenu);
    if (closeMenuBtn) closeMenuBtn.addEventListener("click", closeAsideMenu);

    asideMenu.addEventListener("keydown", (e) => {
      if (e.code === "Escape") closeAsideMenu(e);
    });
  };

  /* Submeniurile sunt absolute fata de .aside-menu__wrapper si se opresc
     deasupra barei de jos. Distanta pana acolo o masuram, nu o presupunem:
     bara isi schimba inaltimea cand selectorul de limba se rupe pe doua
     randuri sau cand butonul de cocktail e stins din editor. */
  const syncAsideBottom = () => {
    const wrapper = document.querySelector(".aside-menu__wrapper");
    const bottom = wrapper && wrapper.querySelector(".menu-drawer__bottom");
    if (!wrapper) return;
    if (!bottom) {
      wrapper.style.setProperty("--aside-bottom-h", "0px");
      return;
    }
    // marginea de jos a wrapperului minus varful barei: include si
    // padding-ul de jos al wrapperului, deci nu trebuie adunat separat
    const gap = wrapper.getBoundingClientRect().bottom
      - bottom.getBoundingClientRect().top;
    wrapper.style.setProperty("--aside-bottom-h", Math.max(0, Math.round(gap)) + "px");
  };

  const watchAsideBottom = () => {
    syncAsideBottom();
    const bottom = document.querySelector(".aside-menu__wrapper .menu-drawer__bottom");
    if (!bottom || !window.ResizeObserver) return;
    if (watchAsideBottom.observer) watchAsideBottom.observer.disconnect();
    watchAsideBottom.observer = new ResizeObserver(syncAsideBottom);
    watchAsideBottom.observer.observe(bottom);
  };

  document.addEventListener("shopify:section:load", () => {
    initAsideMenu();
    watchAsideBottom();
  });
  initAsideMenu();
  watchAsideBottom();
  // wrapperul are inaltime 0 cat timp meniul e inchis pe unele browsere,
  // deci remasuram si la deschidere, si la rotirea ecranului
  window.addEventListener("resize", syncAsideBottom);
  window.addEventListener("orientationchange", syncAsideBottom);
  document.addEventListener("click", (e) => {
    if (e.target.closest && e.target.closest(".aside-menu__toggle--open-btn")) {
      requestAnimationFrame(syncAsideBottom);
    }
  });

  /* Cand un overlay full-screen al temei se deschide peste meniul lateral -
     azi doar Cocktail Builder, pornit din butonul de la baza meniului - meniul
     trebuie sa iasa de sub el. Altfel, la inchiderea overlay-ului utilizatorul
     se trezeste inapoi in meniul deschis, desi el plecase din meniu.
     Evenimentul e emis de sections/cocktail-builder.liquid; acelasi semnal il
     asculta si widgetul de chat ca sa isi ascunda bula.

     Inchidem apasand chiar butonul de inchidere al temei, in loc sa duplicam
     logica: asa se ruleaza si closeAllLevels(), si header.preventHide = false.
     Ascultatorul sta in afara lui initAsideMenu ca sa nu se lege de doua ori
     cand editorul de teme reincarca sectiunea. */
  document.addEventListener("nego:overlay:open", () => {
    if (!document.querySelector(".aside-menu.aside-menu--open")) return;
    const closeBtn = document.querySelector(".aside-menu__toggle--full-close-btn");
    if (closeBtn) closeBtn.click();
  });

  /* NegoStore (perf 09.10.2026): pana aici hamburgerul l-a servit scriptul inline de la finalul
     snippets/aside-menu.liquid (fisierul asta e defer, deci porneste abia la DCL). De acum preiau
     handler-ele de mai sus, iar steagul il opreste pe cel inline: nicio atingere nu e tratata de
     doua ori. Steagul se pune la final, dupa ce totul e legat; daca ceva de mai sus arunca,
     scriptul inline ramane plasa de siguranta. Daca meniul a fost deschis devreme, completam ce
     face openAsideMenu pe langa clase: header.preventHide si masurarea barei de jos, de care se
     opresc submeniurile (syncAsideBottom). Inchiderea o preiau handler-ele normale. */
  window.negoAsideReady = true;
  const preopenedMenu = document.querySelector(".aside-menu.aside-menu--open");
  if (preopenedMenu) {
    preopenedMenu.removeAttribute("data-nego-preopened");
    const headerWrapper = document.querySelector(".header-wrapper");
    if (headerWrapper) headerWrapper.preventHide = true;
    syncAsideBottom();
    requestAnimationFrame(syncAsideBottom);
  }
})();